import React, { createContext, useContext, useState } from "react";

import {
    getMe,
    requestRefreshToken,
    getPublicationUuid,
    setPublicationCode,
} from "helpers/Auth";
import { transform as userTransformer } from "schemas/User";

const authContext = createContext();

export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

function useProvideAuth() {
    const [user, setUser] = useState(null);
    const [publication, setPublication] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    /*
        Verify Auth should only be called once. Currently, called in the ApplicationShell component
        with a sing bound useEffect:

        ```
            useEffect(() => {
                auth.verifyAuth();
            }, []);
        ```
    */
    const verifyAuth = async () => {
        console.info("User verification");
        let me = await getMe();
        if (!me || me === 401) {
            console.info("Request token refresh");
            const refresh = await requestRefreshToken();
            if (refresh) {
                console.info("Restart verification");
                me = await getMe();
            }
        }

        if (!me || me === 401) {
            return false;
        }

        console.info("User verified");
        setUser(userTransformer(me));
        setIsAuthenticated(true);

        if (getPublicationUuid()) {
            const pub = userTransformer(me).licenses.find(
                (license) => license.uuid === getPublicationUuid()
            );
            if (pub) {
                console.info("Publication set");
                setPublicationCode(pub.client_code);
                setPublication(pub);
            }
        }

        return true;
    };

    const reloadAuth = async () => {
        let me = await getMe();
        if (!me || me === 401) {
            console.info("Request token refresh");
            const refresh = await requestRefreshToken();
            if (refresh) {
                console.info("Restart verification");
                me = await getMe();
            }
        }

        if (!me || me === 401) {
            return false;
        }

        setUser(userTransformer(me));
        return true;
    };

    return {
        user,
        publication,
        isAuthenticated,
        verifyAuth,
        reloadAuth,
    };
}
